import React from "react";
import { Route, Redirect } from "react-router-dom";
import CommonLayout from "../layout/CommonLayout"

function querystring(name, url = window.location.href) {
  name = name.replace(/[[]]/g, "\\$&");

  const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)", "i");
  const results = regex.exec(url);

  if (!results) {
    return null;
  }
  if (!results[2]) {
    return "";
  }

  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export default function UnauthenticatedRoute({ component: C, appProps, headerCaptionApplicable, ...rest }) {
  const { isAuthenticated } = appProps;

  const redirect = querystring("redirect");
  return (
    <Route
      {...rest}
      render={props =>
        !isAuthenticated
          ? <CommonLayout {...props} {...appProps} headerCaptionApplicable={headerCaptionApplicable}><C {...props} {...appProps} /></CommonLayout>
          : <Redirect
              to={redirect === "" || redirect === null ? "/" : redirect}
            />}
    />
  );
}
